module.exports = __webpack_public_path__ + "static/media/26.e146c2d5.svg";